module.exports = __webpack_public_path__ + "img/nav-resources.f8ccb129.svg";